import api from "../index";

export const GetInvoiceTemplateListApi = () => api.post('invoicetemplatelist');
export const AddUpdateInvoiceTemplateApi = (data) => api.post('addupdateinvoicetemplete', data);
export const DeleteInvoiceTemplateApi = (data) => api.post('deleteinvoicetemplate', data);

export const GetInvoiceTemplateApi = (id) => api.post('getinvoicetemplate', id);